import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Container,
  AppBar,
  Toolbar,
  Typography,
  TextField,
  Button,
  Alert,
  Box,
} from "@mui/material";
import Atras from "./atras";
import { auth, db } from "../firebase";
import { doc, deleteDoc } from "firebase/firestore";
import {
  EmailAuthProvider,
  reauthenticateWithCredential,
  deleteUser,
} from "firebase/auth";

const DeleteAccount = () => {
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmText, setConfirmText] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setError(null);

    if (confirmText !== "ELIMINAR") {
      setError('Escribí "ELIMINAR" para confirmar.');
      return;
    }

    const user = auth.currentUser;
    if (!user) {
      navigate("/login");
      return;
    }

    setLoading(true);
    try {
      const credential = EmailAuthProvider.credential(user.email, password);
      await reauthenticateWithCredential(user, credential);

      await deleteDoc(doc(db, "users", user.uid));
      await deleteUser(user);

      navigate("/login");
    } catch (err) {
      console.error("Error deleting account:", err);
      if (err.code === "auth/wrong-password" || err.code === "auth/invalid-credential") {
        setError("La contraseña es incorrecta.");
      } else {
        setError("Ocurrió un error al eliminar la cuenta. Intentá de nuevo.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <AppBar position="fixed">
        <Toolbar sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Atras />
          <Typography variant="h6" color="text.primary">
            Eliminar cuenta
          </Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="xs" sx={{ mt: 15, mb: 14 }}>
        <Alert severity="warning" sx={{ mb: 3 }}>
          Esta acción es permanente. Se va a borrar tu perfil, y vas a perder acceso a tus
          proyectos, propuestas y chats. No se puede deshacer.
        </Alert>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          label="Contraseña"
          type="password"
          fullWidth
          margin="normal"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        <TextField
          label='Escribí "ELIMINAR" para confirmar'
          fullWidth
          margin="normal"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
        />
        <Box sx={{ mt: 2 }}>
          <Button
            variant="contained"
            color="error"
            fullWidth
            disabled={loading || !password || confirmText !== "ELIMINAR"}
            onClick={handleDelete}
          >
            Eliminar mi cuenta definitivamente
          </Button>
        </Box>
      </Container>
    </Container>
  );
};

export default DeleteAccount;
